import { render, staticRenderFns } from "./InputAccount1.vue?vue&type=template&id=4bfd4bc6"
import script from "./InputAccount1.vue?vue&type=script&lang=js"
export * from "./InputAccount1.vue?vue&type=script&lang=js"
import style0 from "./InputAccount1.vue?vue&type=style&index=0&id=4bfd4bc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports